import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=31f3fc0d&scoped=true&"
import script from "./bill.vue?vue&type=script&lang=js&"
export * from "./bill.vue?vue&type=script&lang=js&"
import style0 from "./bill.vue?vue&type=style&index=0&id=31f3fc0d&prod&lang=scss&scoped=true&"
import style1 from "./bill.vue?vue&type=style&index=1&id=31f3fc0d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3fc0d",
  null
  
)

export default component.exports